<template>
    <modal @close="closeModal" dusk="dnssec-disable-confirm">
        <div class="u-margin-bottom">
            {{
                trans('domain.dnssec.disable-confirm', {
                    domain: this.domain
                })
            }}
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record" type="submit" @click="disableDnssec">
                {{ trans('domain.dnssec.disable') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import { DnssecApi } from 'relapp-technical-management';

export default {
    components: {
        Modal
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Disable DNSSEC for domain.
         */
        disableDnssec() {
            DnssecApi.disable(this.domain)
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });

                    // Refresh
                    DnssecApi.get(this.routeParams);
                })
                .catch(() => {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: trans('domain.dnssec.status.error_disable')
                    });
                });

            this.$emit('close');
        }
    }
};
</script>
